const apiConst = {
  tabList: '/data/tabList',
  dataDetial: '/data/detail', // 获取数据明细
  dataSearch: '/data/search', // 数据查找
  dataIndex: '/data/index', // 获取数据首页
  dataList: '/data/list', // 获取数据列表
  pieData: '/data/piechar', // 获取饼图数据
  
  submitLoginReg: '/ssoauth/register', // 注册登录
  getCaptcha: '/ssoauth/send', // 获取手机验证码
  submitForget: '/ssoauth/forget', // 忘记密码
  wxThirdBind:'/ssoauth/thirdBind',//微信绑定手机号
  share:'/course/share',//分享邀请码
  getExperience:'/user/experience',//获取体验码

  getUserTags: '/index/userConfig', // 获取用户关注tag
  submitTakecare: '/index/takecare', // 提交关注频道
  submitTagsSort: '/index/category', // 分类保存排序

  getSearch: '/search', // 搜索

  getDiscoverIndex: '/index', // 发现 首页
  getTagNews: '/news/tagNews', // 点击tag获取新闻
  getDigitalIndex: '/digital', //智库 数据首页
  getDigitalTank: '/digital/getTank', // 智库 更多数据
  getDigitalGeneral: '/digital/general', // 智库 概述
  getDigitalDetail: '/digital/detail', // 智库 详情
  submitBuyDigital: '/digital/buy', // 购买智库报告

  getVip: '/user/vip', // vip首页
  getVipMore: '/user/vipmore', // vip更多

  getUserInfo: '/user/userCenter', // 用户中心
  getUserPublished: '/user/published', // 查看用户已发布内容
  submitFollow: '/user/follow', // 关注
  submitUnfollow: '/user/unfollow', // 取关

  getCollegeIndex: '/course/index', // 学院首页
  getCollegeOther: '/course/other', // 学院其他
  getCourseDetail: '/course/detail', // 课程详情
  submitBuyCourse: '/course/buy', // 购买课程
  getSubCate: '/course/courseCate', // 获取课程子分类,
  submitStatistics: '/course/statistics', // 
  submitDownload: '/course/download', // 下载


  getNewsList: '', // 获取新闻列表
  getNewsDetail: '/news/detail', // 获取新闻详情

  getOther: '/index/other', // 发现 其他分类新闻
  getAbout: '/about', // 关于
  getProfile: '/user/getProfile', // 获取个人资料
  submitProfile: '/user/profile', //保存个人资料
  getIndustry: '/user/industry', //获取行业信息
  getSuper: '/user/getSuper', // 获取友绿币
  getPayment: '/payment/option', // 获取充值选项
  submitPayment: '/payment', // 充值
  getHistory: '/user/history', // 历史纪录
  getRecent: '/user/history', // 最近阅读
  getTransaction: '/user/loosecoin', // 友绿币交易明细
  getOrder: '/order/index', // 订单
  getFeedbackTags: '/user/suggestionTag', // 反馈页面的标签
  getAchievement: '/user/achievement', // 成就
  submitFeedback: '/user/suggestionSave', // 提交反馈
  submitImg: '/user/upload', // 上传图片
  getMessage: '/user/message', //消息
  submitPassword: '/user/editPassword', //修改密码
  clearMessage: '/user/clearMsg', // 清除消息
  getFavorite: '/user/collect', //获取收藏
  getFollowing: '/user/attention', // 我的关注
  submitFav: '/user/keep', // 收藏
  submitUnfav: '/user/unkeep', // 取消收藏,
  submitLogout: '/user/logout', // 退出登录
  becomevip:'/user/becomevip', //成为个人VIP
  applePurchase:'/appstore/index', //苹果内购
  tencentBao:'/about/tencent',//腾讯应用宝地址
  appleVipPurchase:'/appstore/buyvip',//购买vip
};

export default apiConst;
